import React from "react"
import Layout from "components/Blog/Layout"
import Landing from "./Landing"
import GroupContainer from "./GroupContainer"

const HowToPlay = (props) => {
	const {
		landing
	} = props

	return (
		<Layout enforceBackground>
			<Landing {...landing} />
			<GroupContainer {...props} />
		</Layout>
	)
}

export default HowToPlay